import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Copy14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.38889 1.25C4.7599 1.25 4.25 1.7599 4.25 2.38889L4.25 8.61111C4.25 9.2401 4.7599 9.75 5.38889 9.75H11.6111C12.2401 9.75 12.75 9.2401 12.75 8.61111V2.38889C12.75 1.7599 12.2401 1.25 11.6111 1.25H5.38889ZM5.75 8.25V2.75L11.25 2.75V8.25H5.75Z'
      fill='currentColor'
    />
    <path
      d='M2.75 3.5L2.75 11.25H10.5V12.75H2.4C1.76487 12.75 1.25 12.2351 1.25 11.6V3.5H2.75Z'
      fill='currentColor'
    />
  </Svg>
);

Copy14.displayName = 'Copy14';
export default Copy14;
